export const TAILWIND_SCALE_MULTIPLIER = 4;
